import EventEmitter from "event-emitter"

class DataProvider {
    private a = 0;
    private data = {};
    private dataVersions = {};
    private fetchDataCallbacks = {};
    private opts: any;
    private dataChangedEventNamePrefix = "data-changed-"
    private eventEmitter = EventEmitter()

    constructor(opts) {
        this.opts = opts
        this.a = 1;
    }

    public getData = async (key) => {
        const value = this.data[key]
        if (value !== undefined) {
            return value
        }
        return await this.opts.getter(key)
    }

    public watchData = async (key, callback, view: any = null, preventFetchAtFirstTime = false) => {
        if (!preventFetchAtFirstTime) {
            if (this.data[key] !== undefined) {
                callback(this.data[key])
            } else {
                try {
                    await this.fetchData(key, (value) => {
                        callback(value)
                    })
                } catch (e) {
                    console.log(e)
                }
            }
        }
        this.eventEmitter.on(this.dataChangedEventNamePrefix + key, callback)
        const self = this
        const cancelFunc = () => {
            self.eventEmitter.off(self.dataChangedEventNamePrefix + key, callback)
        }
        this.addCancelFunc(view, cancelFunc)
        return cancelFunc
    }

    public bindData = async (key, container, vueVm, callback, view: any = null) => {
        const cancelFunc = await this.watchData(key, (data) => {
            if (vueVm) {
                vueVm.$set(container, key, data)
            } else {
                container[key] = data
            }
            callback && callback(data)
        })
        this.addCancelFunc(view, cancelFunc)
        return cancelFunc
    }

    public bindDataMany = async (keys, container, vueVm, callback, view: any = null) => {
        const cancelFuncs = []

        for (const key of keys) {
            if (key) {
                await (async (key) => {
                    const cancelFunc = await this.bindData(key, container, vueVm, (data) => {
                        callback && callback(key, data)
                    })
                    cancelFuncs.push(cancelFunc)
                })(key)
            }
        }

        const cancelAllFunc = () => {
            for (const cancelFunc of cancelFuncs) {
                cancelFunc()
            }
        }
        this.addCancelFunc(view, cancelAllFunc)
        return cancelAllFunc
    }

    public refreshData = async (key, value, persistance: boolean = false) => {
        if (persistance) {
            this.data[key] = value
        }

        if (value !== undefined) {
            const nextDataVersion = this.nextDataVersion(key)
            this.updateNewDataWithVersion(key, value, nextDataVersion)
            this.eventEmitter.emit(this.dataChangedEventNamePrefix + key, value)
        } else {
            await this.fetchData(key, (value) => {
                this.updateNewDataWithVersion(key, value, this.nextDataVersion(key))
                this.eventEmitter.emit(this.dataChangedEventNamePrefix + key, value)
            })
        }
    }

    public unregisterView(view) {
        if (!view) {
            return
        }
        if (!view.dataProviderCancelFuncs) {
            return
        }
        for (const cancelFunc of view.dataProviderCancelFuncs) {
            cancelFunc()
        }
    }

    private nextDataVersion(key) {
        if (!this.dataVersions[key]) {
            this.dataVersions[key] = 0
        }
        this.dataVersions[key] += 1
        return this.dataVersions[key]
    }

    private async fetchData(key, callback) {
        if (!this.fetchDataCallbacks[key]) {
            this.fetchDataCallbacks[key] = []
        }
        this.fetchDataCallbacks[key].push(callback)
        const currentDataVersion = this.nextDataVersion(key)
        const value = await this.opts.getter(key)
        this.updateNewDataWithVersion(key, value, currentDataVersion)
    }

    private updateNewDataWithVersion(key, value, version) {
        if (version !== this.dataVersions[key]) {
            return
        }
        if (!this.fetchDataCallbacks[key]) {
            return
        }
        for (const callback of this.fetchDataCallbacks[key]) {
            callback(value)
        }
        this.fetchDataCallbacks[key] = []
    }

    private addCancelFunc(view, cancelFunc) {
        if (!view) {
            return
        }
        if (!view.dataProviderCancelFuncs) {
            view.dataProviderCancelFuncs = []
        }
        view.dataProviderCancelFuncs.push(cancelFunc)
    }
}

export default DataProvider
